module.exports = __webpack_public_path__ + "static/img/icon-elearning.2eb676f1.svg";